import { deleteLista, getListasPanel } from "../../services/ListaCabServices";
import { ListasCabContext } from "./ListasCabContext"

export const ListasCabState = ({ children }) => {
    const getListasPanelData = async (searchTerm,numPagina, filas) => {
        let res = await getListasPanel(searchTerm,numPagina, filas);
        return res
    }

    const deleteListaData = async (body) => {
        const res = await deleteLista(body)
        return res
    }
   
    return <ListasCabContext.Provider value={{
        deleteListaData,
        getListasPanelData,
    }} >
        {children}
    </ListasCabContext.Provider>
}